<script>
import { dateFormatReadable, money_format, roundOff } from "@/utils";
import moment from "moment";
export default {
  name: "recommendation-card",
  props: ["item"],
  data() {
    return {
      reveal: false
    };
  },
  methods: {
    goto() {
      this.$router.push(`/campaigns`);
    }
  },
  computed: {
    recommendationDisabled(){
      const start = new Date(this.item.analysis_start_date);
      const end = new Date(this.item.analysis_end_date);
      const actual = moment().subtract(30, 'days')
      const withinActual = moment(actual).isBetween(start, end);
      
      return !withinActual
    },
    startDate() {
      return dateFormatReadable(this.item.analysis_start_date);
    },
    endDate() {
      return dateFormatReadable(this.item.analysis_end_date) + " ";
    },
    percentage() {
      let percent = parseFloat(this.item.percentage) * 100;
      return `${roundOff(Math.abs(percent))}%`;
    },
    potential_roi() {
      let amount = parseFloat(this.item.potential_roi);
      return money_format(amount);
    },
    location_name() {
      let item = this.item && this.item.location ? this.item.location : null;
      return `${item.name.replace(item.street, '')}`;
    },
    location_address() {
      let item = this.item && this.item.location ? this.item.location : null;
      return `${item.street} ${item.city} ${item.state}`;
    }
  }
};
</script>

<template>
  <v-card elevation="3" class="rounded-xl p-5">
    <v-card-title class="pb-0">{{ location_name }}</v-card-title>
    <v-card-text class="pt-0">{{ location_address }}</v-card-text>
    <v-card-text>
      <div class="d-flex align-items-top justify-content-between">
        <div>
          <div>POTENTIAL ROI</div>
          <h3 class="text-warning font-weight-bolder">
            {{ potential_roi }}
          </h3>
        </div>
        <div>
          <div class="d-flex align-items-top flex-lg-fill">
            <span class="symbol symbol-40 symbol-light-primary mr-2">
              <span class="symbol-label">
                <span class="svg-icon svg-icon-7x svg-icon-primary">
                  <i class="flaticon2-chart"></i>
                </span>
              </span>
            </span>
            <div class="d-flex flex-column">
              <span class="font-size-h5 font-weight-bold">
                MARKETING
              </span>
              <span class="font-weight-100" style="text-transform: capitalize;">
                {{ item.metric }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="d-flex align-items-top justify-content-between mt-5">
        <div>
          <div class="text-muted">STATUS</div>
          <div>
            <v-btn color="warning" depressed tile>
              Did Not Work
            </v-btn>
          </div>
        </div>
        <div>
          <v-card-actions>
            <v-btn text color="teal accent-4" @click="reveal = true">
              Details
            </v-btn>
          </v-card-actions>
        </div>
      </div> -->

      <div
        class="mt-5 p-2"
        style="text-align: justify; font-size: 12px; font-style: tahoma; line-height: 22px;"
      >
        From {{ startDate }} to {{ endDate }}
        <strong class="color-black">{{ item.metric }}</strong> has been
        <strong class="color-red">{{ percentage }}</strong> below the
        <strong class="color-black">{{ item.metric }}</strong> of the
        <strong class="color-black">{{ item.baseline }}</strong
        >. Not correcting this could lose the business
        <strong class="color-red">{{ potential_roi }}</strong> in revenues over
        the next 30 days
      </div>
      <div class="text-center" >
        <v-btn outlined block color="indigo" @click="goto" :disabled="recommendationDisabled">
          Take Action
        </v-btn>
      </div>
    </v-card-text>
    <v-expand-transition>
      <v-card
        v-if="reveal"
        class="transition-fast-in-fast-out v-card--reveal"
        style="height: 100%;"
      >
        <v-card-text class="pb-0">
          This is a test
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn text color="teal accent-4" @click="reveal = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-expand-transition>
  </v-card>
</template>

<style scoped>
.color-purple {
  color: #5866db;
}
.color-green {
  color: green;
}
.color-red {
  color: red;
}
.color-black {
  color: black;
}
.color-gray {
  color: gray;
}
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
